<section class="tender-info-card">
  <div class="tender-info-card__accent"></div>

  <div class="tender-info-card__body">
    <div class="tender-info-card__badge">
      <i class="iconsax tender-info-card__badge-icon" icon-name="briefcase"></i>
      <span>{{ 'tenders.enterpriseRfp' | translate }}</span>
    </div>

    <h1 class="tender-info-card__title">
      {{ tender()?.title | translateData }}
    </h1>

    <p class="tender-info-card__description">
      {{ tender()?.description | translateData }}
    </p>

    <div class="tender-info-card__authority">
      <div class="tender-info-card__authority-avatar">
        @if (tender()?.business?.logo?.url) {
          <img
            [ngSrc]="(tender()?.business?.logo?.url | imageSource) || ''"
            width="44"
            height="44"
            [alt]="(tender()?.business?.title | translateData) || ''" />
        } @else {
          <i class="iconsax" icon-name="building-4"></i>
        }
      </div>

      <div class="tender-info-card__authority-content">
        <div class="tender-info-card__authority-row">
          <span class="tender-info-card__authority-name">
            {{
              (tender()?.business?.title | translateData) ||
                ('tenders.iweVerifiedAuthority' | translate)
            }}
          </span>
          <span class="tender-info-card__authority-trusted">{{
            'tenders.trusted' | translate
          }}</span>
        </div>
        <p class="tender-info-card__authority-meta">
          {{ 'tenders.jointProcurementBoard' | translate }}
        </p>
      </div>
    </div>
  </div>
</section>
